
export function parseYouTubeUrl(url: string): { youtubeId: string | null; startSeconds?: number } {
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname.replace("www.", "");
    let videoId: string | null = null;

    if (hostname === "youtu.be") {
      videoId = urlObj.pathname.replace("/", "");
    } else {
      videoId = urlObj.searchParams.get("v");
    }

    const timeParam = urlObj.searchParams.get("t") ?? urlObj.searchParams.get("start");

    let startSeconds: number | undefined;
    if (timeParam) {
      const match = timeParam.match(/^(\d+)s?$/);
      if (match) {
        startSeconds = parseInt(match[1], 10);
      }
    }

    return { youtubeId: videoId, startSeconds };
  } catch {
    return { youtubeId: null };
  }
}

export function buildEmbedUrl(youtubeId: string, startSeconds?: number): string {
  const params = new URLSearchParams({
    rel: "0",
    modestbranding: "1",
    vq: "hd1080",
    hd: "1",
    autoplay: "1",
  });

  if (startSeconds != null && startSeconds > 0) {
    params.set("start", startSeconds.toString());
  }

  return `https://www.youtube.com/embed/${youtubeId}?${params.toString()}`;
}
